import { Form, Input, Modal, Popover, Dropdown } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import "./index.scss";
import utils from "utils/index";
import { useHistory } from "react-router-dom";
import indexService from "services/index";

const { confirm } = Modal;

const Index = (props) => {
  const [appList, setAppList] = useState([]);
  const [accountInfo, setAccountInfo] = useState({});
  const [editPwdVisible, setPwdVisible] = useState(false);
  const [form] = Form.useForm();
  const history = useHistory();
  useEffect(() => {
    getAppList();
    getCurrentAccount();
    checkAuthority();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const getAppList = () => {
    indexService.appList().then(({ code, data }) => {
      if (code === 200) {
        setAppList(data || []);
      }
    });
  };
  // 获取当前用户信息
  const getCurrentAccount = () => {
    indexService.getCurrentAccount().then(({ code, data }) => {
      if (code === 200) {
        setAccountInfo(data);
      }
    });
  };
  // 账号未获得授权时给予提示
  const checkAuthority = () => {
    console.log("history", history.location.search);
    console.log("window", window.location.search);
    let result = utils.getQueryString("result");
    if (typeof result === "string" && result.indexOf("NO_AUTHORIZE") >= 0) {
      utils.msg.error("该账号暂未获得系统内授权！");
    }
  };
  const onShowConfirmModal = () => {
    confirm({
      title: "确定要退出登录吗？",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        console.log("OK");
        _confirmLogout();
      },
      onCancel() {
        console.log("Cancel");
      },
      okText: "确认",
      cancelText: "取消",
      content: "",
    });
  };
  // 确认退出登录
  const _confirmLogout = () => {
    // 重定向
    window.location.href = "/sso/logout";
  };
  // 展示修改密码弹框
  const onShowPasswordModal = () => {
    setPwdVisible(true);
  };
  // 隐藏修改密码弹框
  const onCancelPwdModal = () => {
    setPwdVisible(false);
  };
  // 确认修改密码
  const onConfirmEditPwd = () => {
    form
      .validateFields()
      .then(() => {
        const values = form.getFieldValue();
        indexService
          .editPwd({
            newPassword: values.newPassword,
            oldPassword: values.oldPassword,
          })
          .then(({ code }) => {
            if (code === 200) {
              utils.msg.success("修改密码成功");
              if (utils.getStorage("u_pwd")) {
                utils.setStorage("u_pwd", "");
              }
              setTimeout(() => {
                // 重定向
                window.location.href = "/sso/logout";
              }, 1000);
            }
          });
      })
      .catch((err) => {});
  };
  // 跳转到指定app地址
  const redirectToApp = (item) => {
    console.log("12", item);
    window.open(
      item.indexUrl + "?timestamp=" + Date.now(),
      "_blank",
      "noopener"
    );
  };

  const items = [
    {
      key: "1",
      label: <div onClick={onShowPasswordModal}>修改密码</div>,
    },
    {
      key: "2",
      label: <div onClick={onShowConfirmModal}>退出登录</div>,
    },
  ];

  return (
    <>
      <div className="index-container">
        <div className="index-head-box">
          <div className="index-head">
            {/* <img className="head-logo" src={utils.imgList.simLogo} alt="logo" /> */}
            <div className="ih-btn-box">
              <div className="ih-account-info">账号：{accountInfo.account}</div>
              <Dropdown
                menu={{
                  items,
                }}
                trigger="click"
                overlayClassName="ih-dropdown"
              >
                <div className="ih-dropdown-box">
                  <span className="ih-info-icon">用</span>
                  <span className="ih-info-text">{accountInfo.name}</span>
                  {/* <DownOutlined /> */}
                  <img
                    src={utils.imgList.down}
                    alt="图标"
                    className="ih-down"
                  />
                </div>
              </Dropdown>
              {/* <div className="btn btn1" onClick={onShowPasswordModal}>
                                <i className="iconfont icon-unlock"></i>
                                修改密码
                            </div>
                            <div className="btn btn2" onClick={onShowConfirmModal}>
                                <i className="iconfont icon-tuichu"></i>
                                退出登录
                            </div> */}
            </div>
          </div>
        </div>
        {/* <div className="index-info-wrapper">
                    <img src={utils.imgList.headBg} alt="icon" width="100%"/>
                    <div className="index-info-box">
                        <div className="index-info">
                            <div className="i-content">
                                <p className="i-info1">欢迎进入</p>
                                <p className="i-info1">用户统一登录平台</p>
                                <p className="i-info2" style={{ marginTop: '16px' }}>账号：{accountInfo.account}</p>
                                <p className="i-info2">姓名：{accountInfo.name}</p>
                            </div>
                        </div>
                    </div>
                </div> */}
        <div className="index-body">
          {appList.map((item, index) => (
            <div className="app-box-container" key={item.appCode + index}>
              <div className="app-box" onClick={() => redirectToApp(item)}>
                <div className="app-logo-box">
                  <img src={item.logoUrl} alt="app-logo" className="app-logo" />
                </div>
                {item.appName && item.appName.length <= 28 && (
                  <div className="app-name">{item.appName}</div>
                )}
                {item.appName && item.appName.length > 28 && (
                  <>
                    <div className="app-name">
                      {item.appName.substr(0, 28)}
                      <Popover
                        content={() => (
                          <div className="popover-custom-box">
                            {item.appName}
                          </div>
                        )}
                      >
                        &nbsp;<span>...</span>
                      </Popover>
                    </div>
                  </>
                )}
                {/* <div className="app-name">{item.appName}</div> */}
                <div className="switch-btn-box">
                  {/* <div className="switch-btn" onClick={()=>redirectToApp(item)}> */}
                  {/* 开始使用 */}
                  <i className="iconfont icon-jiantou"></i>
                  {/* </div> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {editPwdVisible && (
        <Modal
          className="pwd-wrapper"
          title="修改密码"
          open={editPwdVisible}
          onOk={onConfirmEditPwd}
          onCancel={onCancelPwdModal}
          width="640px"
          okText="确定"
          cancelText="取消"
        >
          <Form
            form={form}
            name="basic"
            labelCol={{ span: 4 }}
            initialValues={{ remember: true }}
            autoComplete="off"
            validateTrigger="onBlur"
          >
            <Form.Item
              label="旧密码"
              name="oldPassword"
              rules={[
                { required: true, message: "请输入旧密码" },
                {
                  validator: (_, value) => {
                    if (
                      !utils.isEmpty(value) &&
                      !/^[A-Za-z0-9$@$!%*#?&_]{1,20}$/.test(value)
                    ) {
                      return Promise.reject(new Error("密码不符合要求"));
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}
            >
              <Input.Password
                placeholder="请输入"
                style={{ width: "320px" }}
                className="inputBox"
                maxLength={20}
              />
            </Form.Item>
            <Form.Item
              label="新密码"
              name="newPassword"
              rules={[
                { required: true, message: "请输入新密码" },
                {
                  validator: (_, value) => {
                    if (
                      !utils.isEmpty(value) &&
                      !/^[A-Za-z0-9$@$!%*#?&_]{1,20}$/.test(value)
                    ) {
                      return Promise.reject(new Error("密码不符合要求"));
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}
            >
              <Input.Password
                placeholder="请输入"
                style={{ width: "320px" }}
                className="inputBox"
                maxLength={20}
              />
            </Form.Item>
            <Form.Item
              label="确认新密码"
              name="confirmPassword"
              rules={[
                { required: true, message: "请再次输入新密码" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("newPassword") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("密码输入不一致"));
                  },
                }),
              ]}
            >
              <Input.Password
                placeholder="请输入"
                style={{ width: "320px" }}
                className="inputBox"
                maxLength={20}
              />
            </Form.Item>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default Index;
